// import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import './App.css';
import Hercules from './Components/Hercules/Hercules.jsx'

function App() {
  // useEffect(() => {
  //   document.title = "Warranty Registration Form - Hercules"
  // }, [])
  return (
    <div>
      <Hercules />
      <Toaster />
    </div>
  );
}

export default App;
